import { ARTICLES_COMPRENDRE } from "./articlesComprendre";
import { ARTICLES_LEGAL } from "./articlesLegal";
import { ARTICLES_DEMARRER } from "./articlesDemarrer";
import { PAGES_SIMPLES } from "./pagesSimples";
import { ARTICLE_COMBINES } from "./articleCombines";
import { GLOSSARY } from "./glossary";
import { ARTICLE as JEU_RESPONSABLE } from "../pages/JeuResponsable";

const strip = (s = "") =>
  s
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const norm = (s = "") =>
  s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "");

const blockText = (b) => {
  if (b.html) return strip(b.html);
  if (b.text) return strip(b.text);
  if (b.items) return b.items.map(strip).join(" ");
  if (b.head || b.rows)
    return [...(b.head || []), ...(b.rows || []).flat()].map(strip).join(" ");
  return "";
};

const articleToEntry = (a) => ({
  title: a.h1,
  path: a.path,
  category: a.category || "Le site",
  description: a.description || "",
  text: [
    a.intro || "",
    ...(a.sections || []).flatMap((s) => [s.h2, ...s.blocks.map(blockText)]),
    ...(a.faq || []).flatMap((f) => [f.q, f.a]),
  ].join(" "),
});

export const SEARCH_INDEX = [
  {
    title: "Accueil — Paris sportifs : comprendre avant de jouer",
    path: "/",
    category: "Accueil",
    description:
      "Guide indépendant et pédagogique pour comprendre les paris sportifs : cotes, cadre légal, inscription, bonus de bienvenue et jeu responsable.",
    text: "cotes règles cadre légal bonus de bienvenue risques guide indépendant 5 choses à savoir avant de parier guides essentiels outils pédagogiques",
  },
  ...[
    ...ARTICLES_COMPRENDRE,
    ARTICLE_COMBINES,
    ...ARTICLES_LEGAL,
    ...ARTICLES_DEMARRER,
    JEU_RESPONSABLE,
    ...PAGES_SIMPLES,
  ].map(articleToEntry),
  ...GLOSSARY.map((g) => ({
    title: `${g.term} — définition`,
    path: "/comprendre/glossaire",
    category: "Glossaire",
    description: g.def,
    text: `${g.term} ${g.def}`,
  })),
];

export function searchSite(query) {
  const q = norm(query.trim());
  if (q.length < 2) return [];
  const terms = q.split(/\s+/);
  return SEARCH_INDEX.map((entry) => {
    const title = norm(entry.title);
    const desc = norm(entry.description);
    const text = norm(entry.text);
    let score = 0;
    terms.forEach((t) => {
      if (title.includes(t)) score += 10;
      if (desc.includes(t)) score += 4;
      const occurrences = text.split(t).length - 1;
      score += Math.min(occurrences, 5);
    });
    return { entry, score };
  })
    .filter((r) => r.score > 0 && terms.every((t) => norm(`${r.entry.title} ${r.entry.description} ${r.entry.text}`).includes(t)))
    .sort((a, b) => b.score - a.score)
    .map(({ entry }) => {
      const text = entry.text;
      const ntext = norm(text);
      const idx = terms.map((t) => ntext.indexOf(t)).find((i) => i >= 0);
      const excerpt =
        idx !== undefined && idx >= 0
          ? (idx > 90 ? "…" : "") +
            text.slice(Math.max(0, idx - 90), idx + 110).trim() +
            (idx + 110 < text.length ? "…" : "")
          : entry.description;
      return { ...entry, excerpt: excerpt || entry.description };
    });
}
